// K-B8 (pre-ship 2026-10-25) — "this is taking a while" for a wait the page
// cannot end itself.
//
// The candidate's camera permission request can stay pending for good: Chrome's
// quiet permission UI shows only an address-bar icon, and a prompt can sit
// behind another window. The request itself must never be cancelled
// (anticheat/camera.ts shares ONE pending getUserMedia), so the page can only
// say where to look. This tells it when: `true` once `active` has held for `ms`
// without a break, `false` again the moment it ends.
import { useEffect, useState } from "react";

export const STILL_WAITING_MS = 10_000;

export function useStillWaiting(active: boolean, ms = STILL_WAITING_MS): boolean {
  const [late, setLate] = useState(false);
  useEffect(() => {
    if (!active) {
      setLate(false);
      return;
    }
    const timer = setTimeout(() => setLate(true), ms);
    return () => clearTimeout(timer);
  }, [active, ms]);
  return active && late;
}
